// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"jU","modalBox":"jU","modal-mask":"jV","modalMask":"jV","close-btn":"jW","closeBtn":"jW","container":"jX","content":"jY","title":"jZ","subTitle":"j0","detail":"j1"};